import React from 'react';
import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../theme/constants';
import { PopperTooltip } from '@emarketer/componentlibrary';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const PremiumPopper: React.FC = (props) => {
  const premiumPopperTag = (
    <PremiumPopperWrapper>
      <PremiumPopperSpan>PRO+</PremiumPopperSpan>
      <InfoIcon icon={faInfoCircle} />
    </PremiumPopperWrapper>
  );

  return (
    <PopperTooltip
      controlShow={false}
      showArrow
      hideBoxShadow
      placement="bottom"
      distance={10}
      target={premiumPopperTag}
    >
      <PopupWrapper>
        <PopupText>PRO+ includes enhanced forecast data.</PopupText>
      </PopupWrapper>
    </PopperTooltip>
  );
};

export default PremiumPopper;

export const PremiumPopperWrapper = styled.div`
  display: inline-block;
  font-size: 10px;
  color: ${COLOR.WHITE};
  ${TYPOGRAPHY.BOLD};
  padding-top: 1px;
  background-color: ${COLOR.BLUE};
  border-radius: 8px;
  padding: 1px 4px 0px 6px;
  margin-left: 6px;

  svg {
    vertical-align: baseline;
  }
`;

export const PremiumPopperSpan = styled.span`
  position: relative;
  bottom: 1px;
`;

export const InfoIcon = styled(FontAwesomeIcon)`
  width: 12px;
  height: 12px;
  color: ${COLOR.WHITE};
  margin-left: 4px;
  position: relative;
  top: 1px;
`;

export const PopupWrapper = styled.div`
  width: 165px;
  box-shadow: 0px 10px 24px 4px #1111111a;
  padding: 8px 16px;
`;

export const PopupText = styled.p`
  margin: 0px;
  ${TYPOGRAPHY.BOLD};
  color: ${COLOR.DARKGREY2};
  font-size: 12px;
`;
